export const RENEW_VIRTUAL_CARD_START = 'RENEW_VIRTUAL_CARD_START';
export const RENEW_VIRTUAL_CARD_SUCCESS =
  'RENEW_VIRTUAL_CARD_SUCCESS';
export const RENEW_VIRTUAL_CARD_ERROR = 'RENEW_VIRTUAL_CARD_ERROR';
export const RENEW_VIRTUAL_CARD_END = 'RENEW_VIRTUAL_CARD_END';
export const CLEAR_RENEW_VIRTUAL_CARD_STORE =
  'CLEAR_RENEW_VIRTUAL_CARD_STORE';
